import PageHeader from "app/shared/PageHeader";
import React, { useEffect, useRef, useState } from "react";
import "./ReportCreate.scss";
import Typography from "app/shared/Typography";
import { colorPicker } from "app/utils/color.helper";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, List, message, Modal, Select } from "antd";
import { API_ENDPOINT_FETCH_DB_TABLES } from "app/scenes/FinkCRM/fink.crm.constants";
import { apiGet, apiPost } from "app/services/apiServices";
import Loader from "app/shared/Loader";
import EmptyState from "app/shared/EmptyState";
import { AgTableClient } from "app/shared/AgTable";
import { DatabaseOutlined } from "@ant-design/icons";
import SearchInput from "app/shared/SearchInput";
import { API_ENDPOINT_REPORT_MANAGER_CREATE } from "../../report.manager.constant";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { useLocation } from "react-router-dom";

export default function ReportCreate(props: any) {
  const [sourceData, setSourceData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [selectedDatabase, setSelectedDatabase] = useState("");
  const [zaId, setZAId] = useState("");
  const [reportName, setReportName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedTable, setSelectedTable] = useState<any>(null);
  const [creating, setCreating] = useState(false);
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [selectedWorkspace, setSelectedWorkspace] = useState<any>(null);
  const [mongoData, setMongoData] = useState<any>(null);
  const [pgData, setPgData] = useState<any>(null);

  const location = useLocation();
  const { db } = location.state || {};


  // let sourceId = "mongodb";
  let sourceId = db;
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const gridRef: any = useRef();
  useEffect(() => {
    if (sourceId === "zohoanalytics") return;
    fetchTableOFDB();
  }, []);
  // const fetchTableOFDB = async () => {
  //   setLoading(true);
  //   const response = await apiGet(API_ENDPOINT_FETCH_DB_TABLES);
  //   setMongoData(response.data?.mongodb)
  //   setPgData(response.data?.postgre)
  //   console.log(response.data, "response for table of db");
  //   if (response.status) {
  //     setSourceData(response.data);
  //   }
  //   setLoading(false);
  // };
  const fetchTableOFDB = async () => {
    setLoading(true);
    const response = await apiGet(API_ENDPOINT_FETCH_DB_TABLES);

    if (response.status) {
      setMongoData(response.data?.mongodb);
      setPgData(response.data?.postgre);


      if (sourceId === "Postgre") {
        setSourceData(response.data?.postgre);
      } else if (sourceId === "mongo") {
        setSourceData(response.data?.mongodb);
      } else {
        setSourceData(null); // or default to one of them
      }
    }

    setLoading(false);
  };


  const sourceNameMap: any = {
    Postgre: "Postgre",
    mongo: "MongoDB",
    zohoanalytics: "Zoho Analytics",
  };

  const getTableDataProcessed = (data: any) => {
    let rowMainData: any = [];
    data.forEach((element: any, key: any) => {
      rowMainData.push({
        sno: key + 1,
        table_name: element,
      });
    });
    return rowMainData;
  };

  const handleSearchWorkspace = (query: string) => {
    if (gridRef.current && gridRef.current.onTableSearch) {
      // Call the child component's function
      gridRef.current.onTableSearch({ target: { value: query } });
    }
  };

  const handleZASchema = () => {
    if (zaId) {
      navigate("/FA/schema/setup", {
        state: { zaId: zaId, sourceType: sourceId },
      });
    } else {
      messageApi.error({
        type: "error",
        content: "Please enter your valid ZA Info",
      });
    }
  };



  // const handleCreateReport = async () => {
  //   console.log("Inside handleCreateReport")
  //   setCreating(true);

  //   // const response = await apiPost(API_ENDPOINT_REPORT_MANAGER_CREATE, {
  //     const response = await apiPost("http://localhost:7002/api/agtable/view/list/reportmanager/create", {
  //     // workspace_id: selectedWorkspace?.[0]?.value,
  //     workspace_id: selectedWorkspace?.map((ws:any) => ws.value),
  //     report_name: reportName,
  //     created_by: userDetails?.name || userDetails?.email,
  //     // workspace_name: selectedWorkspace?.[0]?.name,
  //     workspace_name: selectedWorkspace?.map((ws:any) => ws.name),
  //     dbType: sourceId,
  //     database: selectedDatabase,
  //     table: selectedTable?.table_name,
  //   });
  //   console.log(response,"response from create api")

  //   if (response.status) {
  //     // Check if schema already exists for this table
  //     console.log("Inside try block")
  //     try {
  //       const schemaCheckResponse = await apiPost("http://localhost:7002/api/finalytics/schemas/check", {
  //         tableName: selectedTable?.table_name,
  //         dbType:sourceId,
  //         database:selectedDatabase,
  //       });

  //       if (schemaCheckResponse.status && schemaCheckResponse.data?.exists) {
  //         // Schema exists, skip schema creation and go directly to report view
  //         const existingReportId = schemaCheckResponse.data.reportId;
  //         const workspaceId = schemaCheckResponse.data.workspaceId;
  //         message.success("Schema already exists for this table. Proceeding to report view.");
  //         navigate("/reportmanager/view/" + existingReportId, {
  //           state: {
  //             dbType: sourceId,
  //             database: selectedDatabase,
  //             table: selectedTable?.table_name,
  //             report_name: reportName,
  //             selectedWorkspaceId: workspaceId,
  //             db
  //           },
  //         });
  //       } else {
  //         // No schema exists, proceed to schema creation
  //         console.log("Entered new report creation block")
  //         console.log(response.data,"response data to check")
  //         console.log(selectedWorkspace,"selected workspace to check")
  //         const workspaceIds = selectedWorkspace?.map((ws:any) => ws.value);
  //         console.log(workspaceIds,"workspace ids to check")
  //         navigate("/reportmanager/create/view/schema/" + response.data?.report_id, {
  //           state: {
  //             // reportId:response.data.report_id,
  //             dbType: sourceId,
  //             database: selectedDatabase,
  //             table: selectedTable?.table_name,
  //             report_name: reportName,
  //             // selectedWorkspaceId: selectedWorkspace?.[0]?.value,
  //             selectedWorkspaceId: selectedWorkspace?.map((ws:any) => ws.value),
  //             db
  //           },
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error checking schema:", error);
  //       // On error, proceed to schema creation (fallback)
  //       navigate("/reportmanager/create/view/schema/" + response.data?.id, {
  //         state: {
  //           dbType: sourceId,
  //           database: selectedDatabase,
  //           table: selectedTable?.table_name,
  //           report_name: reportName,
  //           selectedWorkspaceId: selectedWorkspace?.[0]?.value,
  //           db
  //         },
  //       });
  //     }
  //   } else {
  //     message.error("Failed to create report");
  //   }
  //   setCreating(false);
  // };
  const handleCreateReport = async () => {
    setCreating(true);

    let response: any; // declare outside try so it's accessible in catch
    try {
      // 1️⃣ Create report in reports_new
      response = await apiPost(
        "https://stage-apiplatform.finkraftai.com/api/agtable/view/list/reportmanager/create",
        {
          workspace_id: selectedWorkspace?.map((ws: any) => ws.value),
          report_name: reportName,
          created_by: userDetails?.name || userDetails?.email,
          workspace_name: selectedWorkspace?.map((ws: any) => ws.name),
          dbType: sourceId,
          database: selectedDatabase,
          table: selectedTable?.table_name,
        }
      );

      if (!response.status) {
        message.error("Failed to create report");
        return;
      }

      const reportId = response.data?.report_id;
      const workspaceIds = selectedWorkspace?.map((ws: any) => ws.value);

      // 2️⃣ Check if schema exists in AG_TABLE_SCHEMA
      const schemaCheckResponse = await apiPost(
        "https://stage-apiplatform.finkraftai.com/api/finalytics/schemas/check",
        {
          tableName: selectedTable?.table_name,
          reportId,
          workspace_id: workspaceIds,
          dbType: sourceId,
          database: selectedDatabase,
          moduleId: "CRM",
        }
      );

      if (schemaCheckResponse.status && schemaCheckResponse.data?.exists) {
        const stateObject = schemaCheckResponse.data.state;
        message.success(
          "Schema already exists for this table. Proceeding to report view."
        );

        navigate("/reportmanager/view/" + reportId, {
          state: {
            ...stateObject,
            report_name: reportName,
            selectedWorkspaceId: workspaceIds,
            dbType: sourceId,
            database: selectedDatabase,
            table: selectedTable?.table_name,
            db,
          },
        });

      } else {
        navigate("/reportmanager/create/view/schema/" + reportId, {
          state: {
            reportId,
            dbType: sourceId,
            database: selectedDatabase,
            table: selectedTable?.table_name,
            report_name: reportName,
            selectedWorkspaceId: workspaceIds,
            db,
          },
        });
      }
    } catch (error) {
      console.error("Error creating report or checking schema:", error);
      // fallback using response?.data if available
      const reportId = response?.data?.report_id;
      navigate("/reportmanager/create/view/schema/" + reportId, {
        state: {
          reportId,
          dbType: sourceId,
          database: selectedDatabase,
          table: selectedTable?.table_name,
          report_name: reportName,
          selectedWorkspaceId: selectedWorkspace?.map((ws: any) => ws.value),
          db,
        },
      });
    } finally {
      setCreating(false);
    }
  };


  const { Option } = Select;

  const handleSelectWorkspace = (workspaceInfo: any, workspaceFullObj: any) => {
    setSelectedWorkspace(workspaceFullObj);
  };

  const currentSource = sourceData || {};
  const dbList = Object.keys(currentSource);


  return (
    <div className="SchemaSourceDetail">
      <div className="Header">
        <PageHeader
          goBack
          title={`${sourceNameMap?.[sourceId || ""]} Configuration`}
          rightActions={
            <SearchInput
              placeholder="Search Table"
              onSearch={handleSearchWorkspace}
            />
          }
        />
      </div>

      <div className="MainContent">
        {isLoading ? (
          <Loader />
        ) : sourceId !== "zohoanalytics" ? (
          <>
            <div className="DatabaseListContainer">
              <List
                size="small"
                dataSource={
                  // Object.keys(sourceData?.[sourceId || ""] || {}) || []
                  dbList
                }
                renderItem={(item) => (
                  <List.Item onClick={() => setSelectedDatabase(item)}>
                    <DatabaseOutlined
                      style={{
                        marginRight: 4,
                        color: colorPicker("neutral.800"),
                      }}
                    />
                    {item}
                  </List.Item>
                )}
              />
            </div>
            <div className="TableViewContainer">
              {selectedDatabase ? (
                <AgTableClient
                  //@ts-ignore
                  rowData={getTableDataProcessed(
                    Array.isArray(currentSource[selectedDatabase])
                      ? currentSource[selectedDatabase] // PG = array of tables
                      : Object.keys(currentSource[selectedDatabase] || {})
                  )}

                  ref={gridRef}
                  hideToolbar
                  columnDefs={[
                    { field: "sno", headerName: "S.NO" },
                    { field: "table_name", headerName: "Table Name" },
                    {
                      field: "actions",
                      headerName: "Actions",
                      cellRenderer: (params: any) => {
                        return (
                          <div>
                            <Button
                              type="primary"
                              size="small"
                              onClick={() => {
                                setShowModal(true);
                                setSelectedTable(params.data);
                              }}
                            >
                              Create Report
                            </Button>
                          </div>
                        );
                      },
                    },
                  ]}
                  autoResize
                />
              ) : (
                <EmptyState />
              )}
            </div>
          </>
        ) : (
          <div className="ThirdPartySourceContainer">
            <Input
              style={{ width: 400 }}
              placeholder="Enter your ZA Table or View ID"
              onChange={(e: any) => setZAId(e.target.value)}
            />
            <Button
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleZASchema}
            >
              Generate Schema
            </Button>
          </div>
        )}
      </div>
      {contextHolder}

      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={false}
        title="Report Create"
      >
        <div style={{ marginTop: 44 }}>
          <div style={{ marginBottom: 12 }}>
            {/* <Select
              allowClear
              style={{
                width: "100%",
              }}
              mode="multiple"
              placeholder="Select Workspace"
              defaultValue={[]}
              onChange={handleSelectWorkspace}
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().includes(input.toLowerCase()) ||
                option.value.toLowerCase().includes(input.toLowerCase())
              }
            > */}
            <Select
              allowClear
              style={{ width: "100%" }}
              mode="multiple"
              placeholder="Select Workspace"
              defaultValue={[]}
              onChange={handleSelectWorkspace}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children ?? "";
                const value = option?.value ?? "";
                return (
                  children.toString().toLowerCase().includes(input.toLowerCase()) ||
                  value.toString().toLowerCase().includes(input.toLowerCase())
                );
              }}
            >

              {userDetails.workspaces.map((opt: any) => (
                <Option
                  key={opt.id}
                  value={opt.id}
                  meta={opt.meta}
                  domain={opt.domains}
                  name={opt.name}
                >
                  {opt.name}
                </Option>
              ))}
            </Select>
          </div>
          {selectedWorkspace ? (
            <>
              <Input
                placeholder="Report Name"
                onChange={(e: any) => setReportName(e.target.value)}
              />
              <div
                style={{
                  marginTop: 24,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  onClick={handleCreateReport}
                  loading={creating}
                >
                  Create Report
                </Button>
              </div>
            </>
          ) : null}
        </div>
      </Modal>
    </div>
  );
}
